export default {
  "Fleet_Resdesign_Error_OWDd": "El formato del correo electrónico no es válido.",
  "Fleet_Drivers_Please_complete_CZYg": "Por favor, completa primero todos los campos de esta regla.",
  "Fleet_check_hceA_ycnc": "Entendido",
  "Fleet_2_To_be_Egnx": "No vinculados",
  "Fleet_Tool_Links_are_ennN": "Enlace vencido",
  "Fleet_tittle_The_maximum_tjjA": "El periodo máximo que se puede seleccionar es de {{max_time_span}} días.",
  "Fleet_Resdesign_All_XnPT": "Todos",
  "Fleet_check_OQKj_GHLS": "Solo puedes vincular vehículos a conductores después de que se apruebe tu foto de perfil.",
  "Fleet_check_fBNK_CTjZ": "Solo puedes invitar a conductores después de que se apruebe tu foto de perfil.",
  "Fleet_issue_sumF_oFSJ": "Impuestos generados",
  "Fleet_deactivation_sjNc_YjtD": "Cancelar",
  "Fleet_Resdesign_View_Income_PiyV": "Ver detalles de las ganancias",
  "Fleet_start__VNTW": "No has agregado ningún vehículo. Haz clic en “+” para agregar uno.",
  "Fleet_Resdesign_Thursday_JOxF": "Jue",
  "Fleet_perception__ndnz": "Guía de ganancias",
  "Fleet_Drivers_Please_set_HvnQ": "Por favor, configura las ganancias.",
  "upt-city---rwrap_fail": {
    "wtext": "Error al cambiar",
    "wstext1": "No se puede utilizar este modelo.",
    "wstext2": "Error…",
    "wstext3": "Cambiar con éxito"
  },
  "Fleet_start_pHZA_kozl": "¿Quieres cerrar sesión?",
  "upt-city---search": {
    "city-location-none": "Error al posicionarse",
    "back": "Volver",
    "btn-cancel": "Volver",
    "city-location-title": "Ciudad anterior",
    "city-popular-title": "Ciudades preferidas",
    "data_sub": "Nombre de la ciudad",
    "search-content-title": "Buscar ciudad",
    "didi-dialog-p": "Puedes cambiar tu ciudad <em class='org'> {ctime} </em> veces al máximo cada <em class='org'>6</em> meses",
    "btn-ok": "Cambiar"
  },
  "Fleet_Drivers_Confirm_deletion_aXtK": "¿Deseas eliminar la regla?",
  "Fleet_optimizaton__GwKg": "Tus documentos deben estar aprobados para que puedas acceder a la opción de Buscar conductores y agregar conductores.",
  "Fleet_Drivers_Select_Name_OoCI": "Elige el nombre",
  "Fleet_control_ZNQC_ZwIi": "{{Fleet_name}} te invitó a unirte a su flotilla",
  "Fleet_Resdesign_Cash_XfVb": "Pago en efectivo",
  "Fleet_check_aUhi_hmNL": "{{brand_name}} necesita acceder a tus fotos para que puedas configurar tu foto de perfil y usar otros servicios.",
  "GDriver_Enhancement_Repayment_INQd": "Pagar",
  "Fleet_Phase2_Invitation_accepted_jUWV": "Invitación aceptada",
  "Fleet_Drivers_Verification_code_EAbp": "Enviamos el código de verificación al {{phone_number}}.",
  "Fleet_copy_Add_a_QOUx": "Agregar documentos",
  "Fleet_Resdesign_November_kXkU": "nov",
  "Fleet_check_ejnS_VZqp": "Esta foto será tu foto de perfil. Te sugerimos que:",
  "Fleet_check_OaNq_asGe": "Tu foto de perfil fue subida",
  "Fleet_control_The_total_Mche": "Se canceló el pago de tu deuda, por lo que se volverá a calcular tu saldo. Si el monto de la deuda termina siendo demasiado alto, ningún socio arrendador de la flotilla podrá aceptar solicitudes de arrendamiento con pago en efectivo hasta que pagues la deuda.",
  "Fleet_Resdesign_Income_summary_PZsP": "Resumen de ganancias",
  "Fleet_MatchingTool_Loading_ingu": "Cargando",
  "Fleet_0303_Fleet_WorkRegime_Weekly_collection_PFfF": "Se cobra todos los lunes entre las 00:00 y las 12:00",
  "upt-city---tips": "Alteraste este dato demasiadas veces",
  "Fleet_perception__SzYM": "Desempeño de flotilla",
  "Fleet_Drivers_Name_can_JcFB": "El nombre no puede estar en blanco.",
  "Fleet_0303_Fleet_WorkRegime_Enter_name_hIvg": "Selecciona el nombre del cargo",
  "Fleet_Resdesign_No_data_CqQU": "No hay datos.",
  "Fleet_Mgt_Question_feedback_uwFO": "Comentarios",
  "Fleet_control_mIEb_goHs": "Aceptar",
  "Fleet_check_wRSz_suag": "Permitir",
  "Fleet_Resdesign_Saturday_mzeO": "Sáb",
  "Fleet_Mgt__gsvK": "Alquilar",
  "Fleet_FleetRecommendation_Successfully_saved_wLuW": "Se guardó correctamente",
  "Fleet_Resdesign_Sunday_jiVr": "Dom",
  "Fleet_0303_Fleet_WorkRegime_everyday_BKeT": "Diariamente",
  "Fleet_start__EurG": "No has vinculado a ningún conductor. Invita o encuentra uno en la sección de “Conductores”.",
  "Fleet_Resdesign_Confirmation_McBF": "Aceptar",
  "Fleet_Resdesign_Total_lDoG": "Efectivo total recibido",
  "Fleet_Mgt_No_information_DDuc": "Sin información",
  "Fleet_Drivers_Add_slkd": "Agregar",
  "Fleet_Drivers_The_driver_AvoC": "Se aprobaron todos los documentos del conductor.",
  "Fleet_Drivers_Confirmation_jXFy": "Confirmar",
  "Fleet_control_Please_check_tIFA": "Antes de eliminar a este conductor de la flotilla, confirma que no tenga pagos pendientes. ¿Seguro que deseas eliminar al conductor?",
  "Fleet_check_TNKJ_sfGt": "Evites accesorios como gorras o lentes de sol.",
  "Fleet_Phase1_There_are_TYqj": "Aquí puedes buscar conductores.",
  "Fleet_start__OCpm": "Guardado correctamente",
  "dinfo---bank": "Cuenta bancaria",
  "Fleet_Resdesign_January_MKno": "ene",
  "magellan": {
    "martell": {
      "translate": {
        "order_compensate": {
          "driver_channel": {
            "1": "Saldo"
          }
        }
      }
    }
  },
  "Fleet_Tool_Unable_to_jqFL": "No fue posible completar la solicitud para salir de la flotilla. Por favor, inténtalo de nuevo más tarde.",
  "Fleet_Resdesign_Select_End_qdXu": "Hora final",
  "Fleet_Drivers_Next_step_PxoK": "Siguiente",
  "Fleet_copy_Change_UEsW": "Editar",
  "Fleet_Drivers_Rule_number_hDmV": "Regla {{number}}",
  "Fleet_deactivation_DenK_QPgy": "Agregar nuevo vehículo",
  "Fleet_Mgt_Send_a_orZR": "Enviar resumen",
  "Fleet_start__kQXw": "Activar la guía rápida",
  "Fleet_check_zWwS_DPsT": "Pongas tu cara en el centro de la pantalla.",
  "Fleet_Resdesign_Load_last_YWoz": "Cargar mes ant.",
  "Fleet_check_HWak_qoaq": "Subir foto de perfil",
  "Fleet_Drivers_Add_Rules_KTVL": "Agregar regla",
  "Fleet_optimizaton__ZYCj": "Agrega vehículos aquí",
  "Fleet_Drivers_The_driver_wclR": "No se pudo agregar al conductor. Se unió a otra flotilla.",
  "Fleet_start__sbZS": "Atrás",
  "Fleet_start__MHFQ": "Agrega tu tarjeta bancaria",
  "Fleet_Drivers_To_register_MgmZ": "Registrar",
  "Fleet_copy_Driver_XTmX": "Conductores",
  "Fleet_Mgt_Driver_performance_pmda": "Historial del conductor",
  "Fleet_deactivation_AxQl_axxa": "No respondiste los mensajes a tiempo y se quitaron los vehículos relacionados.",
  "Fleet_Resdesign_October_pbZU": "oct",
  "Fleet_Resdesign_Enter_email_cylU": "Ingresar correo",
  "Fleet_Phase1_Driver_Market_lUUD": "Buscar conductores",
  "Fleet_FleetRecommendation_Enter_the_Ykpv": "Ingresa un monto válido",
  "Fleet_Tool_Confirmation_of_xfhT": "Confirmación para salir de la flotilla",
  "Fleet_Mgt_Delete_the_cmct": "¿Quieres eliminar este vehículo?",
  "upt-city---index_city_title": "Cambiar ciudad",
  "Fleet_Mgt_Select_date_INmY": "Selecciona la fecha",
  "Fleet_Drivers_The_driver_mSzg": "Se guardó la configuración para este conductor.",
  "Fleet_MultiUserLogin_Add_succeed_kBCi": "Se agregó correctamente.",
  "Fleet_Drivers_Delete_NcPF": "Eliminar",
  "Fleet_perception__LHEy": "(Yo)",
  "Fleet_Drivers_The_invitation_ytYi": "También se le envió un enlace con la invitación. Por favor, espera a que la acepte.",
  "Fleet_Drivers_Please_help_ZYii": "Para agregar a este conductor, puedes ayudarlo a completar su registro.",
  "dinfo---details": {
    "driver_name_title": "Nombre",
    "driver_city_title": "Ciudad",
    "car_type": "Categoría"
  },
  "Fleet_issue_PMnB_Wfat": "Depósitos (antes imp.)",
  "Fleet_check_qxdW_jahK": "Mantén tu cara centrada",
  "Fleet_start__SeMT": "Contacta a nuevos conductores usando la opción “Encontrar conductores”.",
  "Fleet_Resdesign_Data_loading_pcxE": "Cargando datos...",
  "Fleet_start_DumJ_PRKC": "{{amount}} agregada(s)",
  "Fleet_check_dPXn_jSAI": "Aviso de Privacidad",
  "Fleet_Resdesign_April_Qtaf": "abr",
  "Fleet_0303_Fleet_WorkRegime_Monthly_uzwN": "Mensualmente",
  "Fleet_issue_eOHq_BsKZ": "Total de impuestos",
  "Fleet_optimizaton__AfWb": "Ver avance de la revisión",
  "Fleet_Mgt_Vehicle_Details_ihSv": "Detalles del vehículo",
  "Fleet_FMS_You_have_pFWa": "Falta uno o más campos obligatorios",
  "upt-city---header": "Puedes cambiar tu ciudad {change_time} veces cada seis meses",
  "Fleet_Mgt_Pull_down_YzpV": "Desliza hacia abajo y actualiza",
  "Fleet_Drivers_Start_date_GZYy": "La fecha de inicio no puede estar en blanco.",
  "Fleet_Resdesign_Tuesday_UAxw": "Mar",
  "Fleet_Drivers_Frequency_mzAO": "Frecuencia",
  "Fleet_perception__iBGo": "Historial del conductor",
  "Fleet_Resdesign_Cash_collection_eETn": "Pagos en efectivo",
  "Fleet_Mgt_Change_color_ddUl": "Cambiar el color",
  "Fleet_Tool_Front_Recommended_giVU": "Flotillas sugeridas",
  "Fleet_Resdesign_Start_end_Nnvy": "I/F",
  "Fleet_Resdesign_Account_Amount_kIgR": "Depósitos a la cuenta",
  "Fleet_optimizaton__AoyP": "Los documentos deben estar aprobados para usar esta opción.",
  "Fleet_issue_mmrE_nuXS": "Detalle de impuestos",
  "Fleet_Tool_Want_to_aUcS": "¿Deseas unirte a otra flotilla?",
  "balance_v1---withdraw": "Transferir",
  "Fleet_Wording_Balance_YWuq": "Saldo",
  "Fleet_Resdesign_Total_income_hyAh": "Ganancias netas totales",
  "dinfo---invoice": "Información fiscal",
  "Fleet_Resdesign_Withdrawal_records_KMxk": "Historial de retiros",
  "Fleet_Drivers_Invitation_to_dIQW": "Invitación enviada",
  "Fleet_check_ELEN_crck": "La revisión toma de 24 a 48 horas. Te avisaremos el resultado de la revisión por mensaje de texto y correo electrónico.",
  "Fleet_DriverUnbindFleet_Untied_cPMi": "Desvinculados",
  "Fleet_control_FAQ_djfs": "Información importante:",
  "Fleet_check_pajT_vPwq": "Sube una foto de perfil",
  "Fintech_Payment_management_View_the_VZZP": "Ver historial del saldo",
  "Fleet_Resdesign_Online_SILV": "Pago con tarjeta",
  "Fleet_Tool_If_you_dYhg": "El enlace tiene una vigencia de 7 días. Para solicitar salir de la flotilla, por favor contacta a Soporte DiDi.",
  "Fleet_rental_Week_wLOx": "semana",
  "Fleet_Tool_Untied_successfully_dutX": "Has salido de la flotilla",
  "Fleet_perception_zHgs_UzNz": "Ganancias netas totales",
  "Fleet_Drivers_Enter_the_fNet": "Ingresa el porcentaje de ganancias que corresponderá al conductor, el porcentaje que te corresponderá a ti y la frecuencia del cobro.",
  "Fleet_Tool_Click_to_DNOM": "Haz clic para más detalles.",
  "Fleet_perception_vSVy_IyMZ": "Pagos en efectivo",
  "Fleet_control_Withdrawal_and_dAGM": "Historial de retiros y pagos",
  "Fleet_Drivers_The_driver_FaYT": "Se guardó la configuración para este conductor. Para terminar de agregarlo, ayúdale a completar su registro.",
  "Fleet_Tool_You_have_Trbx": "Tu solicitud para salir de la flotilla se ha completado. Por favor, contacta al socio flotilla para devolver el vehículo.",
  "Fleet_Mgt__Express_dSGM": "{{Express}}",
  "Fleet_copy_Deleted_successfully_Mafm": "Eliminado correctamente",
  "Fleet_Resdesign_Today_s_yBsy": "Ganancias del día",
  "Fleet_control_1_lIfT": "Estás viendo esta página porque tu cuenta tiene deudas pendientes de saldar. Esto sucede porque los conductores de tu flotilla aceptaron más pagos en efectivo que pagos con tarjeta y los pagos recibidos con tarjeta no alcanzan para cubrir los cargos por servicio pendientes de la plataforma. Puedes ver el total de pagos pendientes de tu cuenta o descargar un informe para ver los pagos que corresponden a cada conductor.",
  "Fleet_Drivers_Confirm_that_HlwF": "Una vez que elimines la regla {{number}}, se perderá esta información.",
  "Fleet_start__JhMH": "Si está desactivada, no la verás en la página de inicio.",
  "Fleet_Drivers_Bind_cCCG": "Agregado",
  "Fleet_Resdesign_December_uJlY": "dic",
  "Fleet_Drivers_Select_frequency_YcRq": "Elige la frecuencia",
  "Fleet_Mgt_Loosen_immediately_OZaY": "Suelta la pantalla y actualiza",
  "Fleet_start__ikUr": "Publica tu vehículo para que los conductores que buscan uno puedan verlo.",
  "Fleet_Resdesign_Send_csv_ngwh": "Enviar por correo electrónico",
  "Fleet_MultiUserLogin_Mobile_number_RzUl": "Nota: Si aceptas la invitación, no podrás usar este número de teléfono para registrarte como conductor o socio flotilla.",
  "Fleet_0303_Fleet_WorkRegime_daily_ztIr": "Se cobra todos los días entre las 00:00 y las 12:00",
  "Fleet_control_OK_sQYN": "Entendido",
  "Fleet_Drivers_Separation_rules_eXvM": "Ganancias",
  "Fleet_start_UcCd_UVKp": "{{app_name}} Encuentra",
  "Fleet_copy_Remove_vehicle_DDrG": "Quitar vehículos",
  "Fintech_Payment_Agency__klZT": "Ver más",
  "Fleet_Drivers_Select_a_yuVt": "Elige la fecha inicial",
  "Fleet_Drivers_Please_set_YncL": "Configura su perfil",
  "Fleet_0303_Fleet_WorkRegime_monthly_XmGW": "Se cobra el primer día de todos los meses entre las 00:00 y las 12:00",
  "Fleet_Phase3_Set_ozBm": "Configuración",
  "Fleet_Resdesign_July_Zroi": "jul",
  "Fleet_control_The_two_wIUS": "Existen dos métodos de pago: 1) pago con tarjeta bancaria, el cual suele procesarse en 10 minutos, y 2) el pago en efectivo, el cual se procesa de 1 a 2 días hábiles. Para ver el estado de tu pago, haz clic en el botón de la parte superior derecha. Si un pago no se refleja correctamente a tiempo, comunícate con {{mx_contact_info}}.",
  "Fleet_Resdesign_August_mcie": "ago",
  "Fleet_issue_WMHZ_ZyWR": "Ganancias totales (antes imp.)",
  "Fleet_Resdesign_Calendar_mFPf": "Calendario",
  "Fleet_start__xLsd": "Ir ahora",
  "Fleet_Drivers_Amount_YOtw": "Monto",
  "Fleet_Resdesign__Biaz": "mar",
  "Fleet_Resdesign_End_HlIj": "Fin",
  "Fleet_check_IYER_eDig": "Solo puedes vincular vehículos a conductores de tu flotilla después de que se apruebe tu foto de perfil.",
  "Fleet_check_PFze_fown": "Estamos revisando tu foto de perfil",
  "Fleet_Mgt_Are_you_QgSa": "Al dar clic en “Confirmar”, el vehículo quedará eliminado.",
  "Fleet_Resdesign_Enter_the_ejUB": "Ingresa tu correo electrónico para enviarte el resumen de ganancias en un archivo CSV.",
  "Fleet_Drivers_Enter_verification_AAuw": "Ingresa el código de verificación",
  "Fleet_Drivers_Enter_a_HciF": "Por favor, ingresa un número de celular válido.",
  "Fleet_control_pbwt_loki": "Ahora no",
  "Fleet_deactivation_xUfQ_GyUZ": "Se quitó/quitaron tu(s) vehículo(s)",
  "Fleet_Drivers_Enter_the_WTcT": "Ingresa monto a obtener",
  "Fleet_check_OZWz_BEqb": "Subir ahora",
  "Fleet_check_vdqm_jUYr": "No volver a mostrar",
  "Fleet_Resdesign__ucKv": "may",
  "Fleet_Drivers_Rules_of_YEUJ": "Configuración guardada",
  "Fleet_perception__oMHQ": "Ver detalles",
  "Fleet_DriverUnbindFleet_Bind_afzf": "Vinculados",
  "Fleet_Drivers_Enter_the_Iqvb": "Ingresa el número de celular del conductor",
  "Fleet_Resdesign_Select_Start_CdGi": "Hora inicial",
  "Fleet_Resdesign_Income_flow_fcPZ": "Detalles de las ganancias",
  "Fleet_check_tint_NtpW": "Te notificaremos el resultado de la revisión en un plazo de <span>24 a 48 horas</span> por mensaje de texto y correo electrónico.",
  "Fleet_Resdesign_Heaven_Qvoz": "día(s)",
  "Fleet_Drivers_There_are_mefN": "Algunas reglas siguen incompletas. Si guardas ahora, se perderán las reglas incompletas.",
  "Fleet_perception__TFIy": "Detalles de las ganancias",
  "Fleet_Drivers_Confirm_deletion_XNBw": "¿Deseas eliminar la regla {{number}}?",
  "Fleet_Mgt_No_more_mlms": "No hay más datos",
  "Fleet_copy_Bind_the_USYf": "Agregar vehículos",
  "Fleet_Drivers_Select_the_njUQ": "Elige nombre de tarifa",
  "Fleet_control_GyDm_gKOe": "Contactar al socio flotilla",
  "Fleet_Mgt_Editing_documents_khkk": "Editar documentos",
  "Fleet_Resdesign_Total_income_XZbI": "Ganancias totales",
  "Fleet_optimizaton__sPaq": "Los documentos que enviaste siguen en revisión o uno o más de los documentos no fueron aprobados. Puedes abrir la app para agregar vehículos y ver más opciones.",
  "Fleet_Drivers_The_amount_WtWG": "El monto no puede estar en blanco.",
  "Fleet_Mgt_Vehicles_GLnp": "Vehículos",
  "Fleet_Drivers_Add_a_rMLY": "Agregar conductor",
  "Fleet_control2_Are_you_Pujl": "¿Deseas quitar al conductor?",
  "Fleet_Drivers_Vehicle_binding_mfjS": "Vehículo",
  "Fleet_Resdesign_Sent_successfully_wwMu": "Correo enviado",
  "Fleet_Resdesign_June_slTp": "jun",
  "Fleet_copy_Vehicle_list_PmvG": "La lista de vehículos está vacía",
  "Fleet_Resdesign_Page_Name_OKXD": "Inicio",
  "Fleet_Drivers_Please_set_nduh": "Configura las ganancias",
  "Fleet_start__dyuk": "Agregar vehículos",
  "Fleet_check_Admw_cABo": "Ahora no",
  "Fleet_Resdesign_Clear_uVXL": "Borrar",
  "Fleet_Drivers_Mobile_number_sgwd": "Número de celular",
  "Fleet_Resdesign_Wednesday_IHFc": "Mié",
  "Fleet_check_XDUC_GDrR": "Ejemplo",
  "Fleet_check_GbcB_hlpe": "Sube una foto de perfil como se indica abajo. Si se rechaza tu foto, es posible que no puedas acceder a algunas funciones.",
  "Fleet_perception__gmNA": "Descargar informe",
  "Fleet_check_GKhX_RGRf": "Tengas buena iluminación y no uses filtros.",
  "Fleet_Tool_Cancel_axjb": "Cancelar",
  "Fleet_Resdesign_Monday_bazB": "Lun",
  "Fleet_start__eaYV": "Puedes agregarla de nuevo cuando quieras desde Mi perfil > Configuración.",
  "Fleet_Resdesign_Send_IBLm": "Enviar",
  "Fleet_Tool_Confirmation_vzhv": "Confirmar",
  "Fleet_Drivers_Select_the_tKMG": "Frecuencia de pago",
  "Fleet_Tool_You_need_ewbc": "Por favor, confirma que deseas dejar la flotilla dentro de los próximos 7 días. Luego de ese periodo, el enlace vencerá y será necesario que contactes a Soporte DiDi nuevamente.",
  "Fleet_perception_Ferf_lkOZ": "Depósitos a la cuenta",
  "Fleet_Drivers_Content_may_ZBiI": "Completa los campos para no perder información",
  "Fleet_check_LJzu_FVZT": "Muestra tu cara completa",
  "Fleet_Resdesign_Cash_LiLC": "Efectivo",
  "Fleet_Drivers_Save_feyd": "Guardar",
  "Fleet_Phase1_Go_vwbQ": "Ir",
  "Fleet_Drivers_Daily_00_kmqY": "Diario: se cobra todos los días entre las 00:00 y las 12:00 horas.\nSemanal: se cobra todos los lunes entre las 00:00 y las 12:00 horas.\nMensual: se cobra el primer día del mes entre las 00:00 y las 12:00 horas.",
  "Fleet_0303_Fleet_WorkRegime_weekly_fELn": "Semanalmente",
  "Fleet_check_UBBv_ALyB": "No uses accesorios",
  "Fleet_0303_Fleet_WorkRegime_amount_obtained_otsv": "Ingresa el monto que obtendrás",
  "Fleet_start__rZdn": "Guía rápida",
  "Fleet_Drivers_Are_you_uWrh": "Haz clic en “Confirmar” si deseas borrar esta regla.",
  "Fleet_start_VrwW_czSn": "Cerrar sesión",
  "Fleet_Resdesign_Total_tUqe": "Depósitos a la cuenta",
  "Fleet_Resdesign_Slide_more_YbCQ": "Desliza hacia arriba para cargar más",
  "Fleet_Resdesign_Start_SDWR": "Inicio",
  "Fleet_Resdesign_September_MGfs": "sep",
  "Fleet_Resdesign_Driver_Summary_zoSe": "Resumen de ganancias del conductor",
  "Fleet_payment_Payment_Method_vmsQ": "Método de pago",
  "Fleet_Resdesign_February_XtXo": "feb",
  "Fleet_start__pvQo": "Sin agregar",
  "Fleet_start__ASwv": "¿Deseas ocultar la guía?",
  "Fleet_optimizaton__OUwE": "Documentos en revisión",
  "Fleet_start__AAdW": "Invitar conductores",
  "Fleet_start_aTFD_HHTY": "Acerca de la aplicación",
  "Fleet_Drivers_Return_Driver_SuUV": "Volver a la lista",
  "Fleet_Drivers_Cancel_YjzD": "Cancelar",
  "Fleet_Drivers_Frequency_can_jPlc": "La frecuencia no puede estar en blanco.",
  "Fleet_control2_Vehicles_not_cNeS": "No se pudo quitar el vehículo",
  "Fleet_check_bHXh_cGKL": "Tu foto fue aprobada y no es necesario volver a subirla.",
  "Fleet_Resdesign_Save_it_uMek": "¿Deseas guardar esta dirección de correo para usarla en el futuro?",
  "Fleet_check_KSPJ_glKu": "Subir",
  "Fleet_issue_uzuL_mYUR": "Para obtener las ganancias netas por conductor, te recomendamos que restes este monto de las ganancias totales de cada conductor antes de impuestos y los depósitos antes de impuestos. Haz clic para obtener más información.",
  "Fleet_Drivers_The_driver_haLf": "No se pudo agregar al conductor. Tiene pagos pendientes.",
  "Fleet_check_XKad_fPlI": "Vuelve a subir tu foto de perfil",
  "Fleet_Resdesign_Friday_GxZE": "Vie",
  "Fleet_start__ndBl": "Ocultar guía",
  "Fleet_copy_No_vehicle_KXvt": "No se agregaron vehículos",
  "Fleet_Resdesign_Balance_GHxU": "Cuenta",
  "GDriver_model__chvL": "Abonar",
  "Fleet_perception__mEjw": "Desglose de las ganancias de la flotilla",
  "Fleet_Drivers_At_the_IfBL": "Inicio",
  "Fleet_Drivers_Name_nwDP": "Nombre",
  "Fleet_control_You_can_UzFy": "Los vehículos no pueden eliminarse de la flotilla hasta que se haya pagado la deuda reciente.",
  "Fleet_Resdesign_Not_selected_xuLq": "Sin elegir",
  "Fleet_control_Repayment_records_uMeU": "Historial de pago",
  "Fleet_check_iuvA_xbpz": "Subir foto de perfil",
  "Fleet_Drivers_Confirmation_wvYD": "Confirmar",
  "Fleet_Mgt_My_driver_nueB": "Mis conductores",
  "Fleet_Resdesign_Saved_Rbay": "Correo guardado",
  "Fleet_Mgt_Please_select_zmgM": "Selecciona al menos un vehículo.",
  "Fleet_perception__akHT": "Recuerda pagar las deudas pendientes pronto para asegurarte de poder retirar tus ganancias. Haz clic aquí para ver los detalles.",
  "Fleet_Resdesign_Data_loading_WbGr": "Datos cargados",
  "Fleet_issue_nMWy_QVYj": "Depósitos (tras imp.)",
  "Fleet_copy_Vehicles_dwty": "Vehículos",
  "Fleet_check_CBpH_TcGJ": "Elijas un fondo simple, de preferencia blanco.",
  "Fleet_issue_wggA_MxPE": "Ganancias netas totales (tras impuestos)",
  "Fleet_issue_aIsE_dmqL": "Conductores",
  "upt-city---submit": "Cambiar ciudad",
  "Fleet_start__tmar": "Atrás",
  "Fleet_Drivers_Go_Bind_TxwZ": "Agregar",
  "Fleet_copy_My_pzKZ": "Mi perfil",
  "Fleet_start_vHHF_ayCO": "Seguridad de la cuenta",
  "Fleet_Drivers_Go_Settings_vpjg": "Configuración",
  "Fleet_Drivers_Settings_zKsG": "Completado",
  "Fleet_check_uiYb_OxPW": "Tu foto de perfil fue rechazada {{reject_max_time}} veces. Para usar esta función, sube una foto válida y espera la aprobación.",
  "Fleet_check_kLTg_CIuk": "Tomar foto",
  "Fleet_check_fHaJ_tEra": "Tomes la foto de los hombros hacia arriba.",
  "Fleet_check_mDSh_CVHS": "Te sugerimos que",
  "Fleet_Resdesign_Total_unit_iLuD": "Viajes totales",
  "unbindTips": "¿Deseas eliminar el vehículo? El conductor no podrá usarlo.",
  "unbindSuccessTips": "Eliminado correctamente",
  "my_wallet": "Billetera",
  "bindTips": "¿Deseas agregar el vehículo al perfil del conductor?",
  "bindSuccessTips": "Agregado correctamente",
  "Fleet_NewPaymentFlow__NhvB": "Amount: {{Price}}. Charged from: {{begin_datetime}}. Frequency: {{Frequency}}.",
  "Fleet_NewPaymentFlow_xuka_dUSy": "If you switch to Automatic Collection, rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance. you’ll need to collect the rest from the driver offline",
  "Fleet_NewPaymentFlow_svTo_tbpj": "To change the collection method, please go to Me > Settings",
  "Fleet_NewPaymentFlow__xbNM": "Add a New Expense",
  "Fleet_NewPaymentFlow__UJcK": "My Earnings",
  "Fleet_NewPaymentFlow__djTl": "Total",
  "Fleet_NewPaymentFlow_utjU_KAIH": "Offline",
  "Fleet_NewPaymentFlow__otGL": "All Bills",
  "Fleet_NewPaymentFlow__fiLG": "Unreceived",
  "Fleet_NewPaymentFlow_ebKy_pywA": "Received",
  "Fleet_NewPaymentFlow_QOhW_ZVsb": "Unlink Vehicle?",
  "Fleet_NewPaymentFlow__nIsf": "Received Offline",
  "Fleet_NewPaymentFlow_wngD_YWNt": "In effect",
  "Fleet_NewPaymentFlow__wxAJ": "Driver Performance",
  "Fleet_NewPaymentFlow_owVN_GnVJ": "Expense Collection Method",
  "Fleet_NewPaymentFlow_fsqE_HdZG": "Unreceived",
  "Fleet_NewPaymentFlow__yfXt": "Edit Expense",
  "Fleet_NewPaymentFlow_cfGZ_kjVX": "The current vehicle has unpaid expenses. Please unlink the vehicle from the driver, then try to change the collection method",
  "Fleet_NewPaymentFlow__uHzl": "Total amount of effective expenses received in the selected period. Includes amounts received but not withdrawn, received and withdrawn and received offline",
  "Fleet_NewPaymentFlow__RjDW": "Frequency",
  "Fleet_NewPaymentFlow__ltIu": "Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline",
  "Fleet_NewPaymentFlow__cGLW": "Please note that after you accept an invitation and successfully join a fleet, the fleet partner will be able to add or edit an expense without further confirmation from you.",
  "Fleet_NewPaymentFlow__BFLZ": "Next",
  "Fleet_NewPaymentFlow_LJUV_JguU": "If you switch to Offline Collection, expenses will not be deducted automatically from the driver’s Wallet, and you’ll need to collect payments from the driver offline",
  "Fleet_NewPaymentFlow_OSHq_PQkz": "Please select a vehicle",
  "Fleet_NewPaymentFlow_gXEl_ipjf": "Not in effect",
  "Fleet_NewPaymentFlow__yzdB": "Vehicle Details",
  "Fleet_NewPaymentFlow__VAgV": "Show More",
  "Fleet_NewPaymentFlow__OPXo": "Disable This Expense?",
  "Fleet_NewPaymentFlow__PRyq": "Daily",
  "Fleet_NewPaymentFlow__IogO": "Total Received",
  "Fleet_NewPaymentFlow__zuWo": "Driver’s mobile number: {{phone_num}}",
  "Fleet_NewPaymentFlow__oIIp": "Bill List",
  "Fleet_NewPaymentFlow__xwbw": "Download Report",
  "Fleet_NewPaymentFlow_ozwI_goeV": "Disabled",
  "Fleet_NewPaymentFlow__bEhi": "Rental fees and other expenses will be automatically deducted from your Wallet",
  "Fleet_NewPaymentFlow__EBXA": "Offline Collection: You will need to pay rental fees and other expenses to the fleet partner offline",
  "Fleet_NewPaymentFlow__xLMz": "Rental fees and other expenses will need to be settled with the fleet partner offline",
  "Fleet_NewPaymentFlow__HtrY": "Accept",
  "Fleet_NewPaymentFlow__ZxdF": "Received Amount Details",
  "Fleet_NewPaymentFlow_ppMF_fAZz": "Please Unlink Vehicle First",
  "Fleet_NewPaymentFlow__sXzn": "Edit Expense",
  "Fleet_NewPaymentFlow__tgtT": "Rental Fee",
  "Fleet_NewPaymentFlow__WiKw": "Details",
  "Fleet_NewPaymentFlow__gTTE": "Received Online",
  "Fleet_NewPaymentFlow__qbqz": "Total Amount Received",
  "Fleet_NewPaymentFlow__GUTP": "One-time Fee",
  "Fleet_NewPaymentFlow__sJZs": "Fleet Invitation",
  "Fleet_NewPaymentFlow__JGoj": "Collection Method",
  "Fleet_NewPaymentFlow__Wzlo": "Set up rental fees and other expenses",
  "Fleet_NewPaymentFlow_lHPn_FNIg": "Please enter an expense name",
  "Fleet_NewPaymentFlow_ecXd_ctUR": "Expense Type",
  "Fleet_NewPaymentFlow__Qbnn": "Total amount of unreceived effective expenses in the selected period",
  "Fleet_NewPaymentFlow__pMHK": "Bill List",
  "Fleet_NewPaymentFlow__GwuJ": "Notes",
  "Fleet_NewPaymentFlow_BBWr_ImCE": "The current vehicle has unpaid expenses. Please unlink the vehicle from the driver, then try to delete it",
  "Fleet_NewPaymentFlow__xiMh": "Collect Offline",
  "Fleet_NewPaymentFlow_TMhC_InJP": "Are you sure you want to delete this vehicle?",
  "Fleet_NewPaymentFlow__GCoA": "Effective Date",
  "Fleet_NewPaymentFlow__EnGk": "Deduction Date",
  "Fleet_NewPaymentFlow__ZQOF": "Next",
  "Fleet_NewPaymentFlow__AMrP": "You’ll need to collect rental fees and other expenses from the driver offline",
  "Fleet_NewPaymentFlow__VoUq": "If you disable this expense, you will no longer receive payments for it starting from the next collection period",
  "Fleet_NewPaymentFlow__TkSG": "Contact Fleet",
  "Fleet_NewPaymentFlow_sKlJ_uHRX": "Expense {{num}}",
  "Fleet_NewPaymentFlow__PsNL": "Total Receivable Amount",
  "Fleet_NewPaymentFlow_ayYQ_vGUU": "Driver’s mobile number",
  "Fleet_NewPaymentFlow__aQyj": "Add Other Expenses",
  "Fleet_NewPaymentFlow__oKdN": "Add Offline Collection Record",
  "Fleet_NewPaymentFlow__upZL": "Expense Type",
  "Fleet_NewPaymentFlow__ELan": "Effective Date",
  "Fleet_NewPaymentFlow__cQQc": "Unreceived",
  "Fleet_NewPaymentFlow__nJcc": "All Drivers",
  "Fleet_NewPaymentFlow_mTod_iDbL": "Receivables",
  "Fleet_NewPaymentFlow__GiSP": "Effective Date",
  "Fleet_NewPaymentFlow__vurJ": "Automatic Collection: Rental fees and other expenses will be deducted automatically from your Wallet. If your balance is insufficient, you’ll need to pay the rest to the fleet partner offline",
  "Fleet_NewPaymentFlow__wclB": "Please read and confirm the rental fees and other expenses info. Tap Accept to join the fleet",
  "Fleet_NewPaymentFlow__XoLO": "Total amount of effective expenses in the selected period",
  "Fleet_NewPaymentFlow__ydGV": "Rental Info",
  "Fleet_NewPaymentFlow_xaDm_BLCM": "The current vehicle has unpaid expenses of {{Price}}. Please settle the amount first. If you’ve received payment, you can adjust the unsettled amount to 0",
  "Fleet_NewPaymentFlow__znZG": "This driver has unpaid expenses of {{Price}}. Please settle the amount first. If you’ve received payment, you can adjust the unsettled amount to 0",
  "Fleet_NewPaymentFlow__Khbs": "Automatic",
  "Fleet_NewPaymentFlow__DRkc": "Disable Expense",
  "Fleet_NewPaymentFlow__VKFl": "Not Now",
  "Fleet_NewPaymentFlow__MfyW": "{{Fleet_name}} invited you to join their fleet",
  "Fleet_NewPaymentFlow__owTK": "Select a vehicle for the driver",
  "Fleet_NewPaymentFlow__yYUL": "Remove This Driver?",
  "Fleet_NewPaymentFlow__CFxF": "Driver’s Bill Details",
  "Fleet_NewPaymentFlow_FMtz_Fgwk": "Switch to Offline Collection?",
  "Fleet_NewPaymentFlow_MOPD_sBcZ": "Received",
  "Fleet_NewPaymentFlow__Hecx": "Skip This Step",
  "Fleet_NewPaymentFlow__IqzA": "Driver’s Bill List",
  "Fleet_NewPaymentFlow__ifcR": "Date Disabled",
  "Fleet_NewPaymentFlow_GZpD_WRgn": "Switch to Auto Collection?",
  "Fleet_NewPaymentFlow__BevI": "Weekly",
  "Fleet_NewPaymentFlow_iJcz_jiCd": "Inviting",
  "Fleet_NewPaymentFlow__eItp": "Received",
  "Fleet_NewPaymentFlow_BoPa_SvIW": "Online",
  "Fleet_NewPaymentFlow__BVvn": "Offline",
  "Fleet_NewPaymentFlow__Mhyi": "Delete"
}